module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-01.a775299b.png";